import styled from 'styled-components'
export const CarbonReductionWarp = styled.section`
    height: 1.58rem;
    background: linear-gradient(93deg,#2fc14c 2%, #3bca30 97%);
    border-radius: .12rem;
    box-shadow: 0px .04rem .16rem 0px rgba(0,36,96,0.06);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right:.5rem ;
    padding-left:.3rem ;
    margin-top: 0.2rem;
    h2{
        font-size: .3rem;
        font-weight: 600;
        color: #fff;
        i{
            font-size: .48rem;
            font-weight: 600;
            color: #fff;
            margin-left: 0.2rem;
        }
    } 
    
    img{
        width: 1.50rem;
        height: .72rem;
    }
`;
